/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type DeleteProgramMutationVariables = Types.Exact<{
  programId: Types.Scalars['String']['input'];
  organizationId: Types.Scalars['String']['input'];
  deleteControls: Types.Scalars['Boolean']['input'];
}>;

export type DeleteProgramMutation = {
  __typename?: 'mutation_root';
  delete_program_by_id?: {
    __typename?: 'GeneralActionOutput';
    message: string;
    status: number;
  } | null;
};

export const DeleteProgramDocument = `
    mutation DeleteProgram($programId: String!, $organizationId: String!, $deleteControls: Boolean!) {
  delete_program_by_id(
    object: {programId: $programId, organizationId: $organizationId, deleteControls: $deleteControls}
  ) {
    message
    status
  }
}
    ` as string & TypedDocumentNode<DeleteProgramMutation, DeleteProgramMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    DeleteProgram: build.mutation<DeleteProgramMutation, DeleteProgramMutationVariables>({
      query: (variables) => ({ document: DeleteProgramDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useDeleteProgramMutation } = injectedRtkApi;
